import { BASE_URL_API } from "constants/base-url-api";

type APIResponse = {
  email: string;
  company: {
    name: string;
    logo_url: string;
  };
};

export const validateCompanyToken = async (companyToken: string) => {
  try {
    const response = await fetch(
      `${BASE_URL_API}/companies/employees/validate/?token=${companyToken}`
    );

    if (response.status === 400) {
      return {
        type: "error",
        status: 400,
        message: "Token inválido",
      };
    }

    if (response.status === 409) {
      return {
        type: "error",
        status: 409,
        message: "Token já utilizado",
      };
    }

    if (response.status !== 200 && response.status !== 500) {
      return {
        type: "error",
        status: response.status,
        message: "Tivemos um problema ao validar o token da empresa",
      };
    }

    const { company } = (await response.json()) as APIResponse;

    return {
      type: "success",
      company,
    };
  } catch (error) {
    return {
      type: "error",
      status: 500,
      message: "Erro interno do servidor",
    };
  }
};
